import axios from 'axios'

export default {
  methods: {
    moveReportPage (type = '') {
      const url = this.$route.params.url
      axios.post('/api/report/init', {url: encodeURIComponent(url), type: type})
        .then(response => {
          const result = response.data
          // console.log('result : ', result)
          if (result && result.router_name !== '') {
            this.$router.push({name: result.router_name, params: result})
          }
        })
        .catch(() => {
          this.$router.push({name: 'PAGE_NOT_FOUND'})
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/report.js